import * as React from "react";
import { Tooltip as TooltipPrimitive } from "radix-ui";

import { cn } from "@/lib/utils/index";
import { Info } from "lucide-react";

function TooltipProvider({ delayDuration = 0, ...props }) {
  return (
    <TooltipPrimitive.Provider
      data-slot="tooltip-provider"
      delayDuration={delayDuration}
      {...props}
    />
  );
}

function Tooltip({ ...props }) {
  return <TooltipPrimitive.Root data-slot="tooltip" {...props} />;
}

function TooltipTrigger({ ...props }) {
  return <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />;
}

// function TooltipContent({
//   className,
//   sideOffset = 0,
//   children,
//   ...props
// }) {
//   return (
//     <TooltipPrimitive.Portal>
//       <TooltipPrimitive.Content
//         data-slot="tooltip-content"
//         sideOffset={sideOffset}
//         className={cn(
//           "z-50 w-fit origin-(--radix-tooltip-content-transform-origin) animate-in rounded-md bg-foreground px-3 py-1.5 text-xs text-balance text-background fade-in-0 zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
//           className
//         )}
//         {...props}>
//         {children}
//         <TooltipPrimitive.Arrow
//           className="z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px] bg-foreground fill-foreground" />
//       </TooltipPrimitive.Content>
//     </TooltipPrimitive.Portal>
//   );
// }

function TooltipContent({ className, sideOffset = 6, children, ...props }) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        data-slot="tooltip-content"
        sideOffset={sideOffset}
        className={cn(
          "z-50 max-w-[240px] origin-(--radix-tooltip-content-transform-origin) animate-in rounded-lg shadow-lg",
          "bg-white text-slate-700 border border-slate-200",
          "dark:bg-slate-800 dark:text-slate-200 dark:border-slate-700",
          "px-3.5 py-2 text-xs font-medium leading-relaxed tracking-wide",
          "text-left",
          "fade-in-0 zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
          className,
        )}
        {...props}
      >
        {children}
        <TooltipPrimitive.Arrow className="z-50 size-2 translate-y-[calc(-50%_-_1px)] rotate-45 rounded-[1px] bg-white fill-white dark:bg-slate-800 dark:fill-slate-800" />
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  );
}

export const InfoDot = ({ tip }) => {
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex cursor-pointer text-muted-foreground hover:text-foreground outline-none">
            <Info className="h-3 w-3" />
          </span>
        </TooltipTrigger>

        <TooltipContent
          side="top"
          align="center"
          sideOffset={6}
          className="max-w-xs"
        >
          {tip}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
